(() => {
  if (customElements.get('cyco-split-size-finder')) return;
  class SplitFinder extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        if (!this.isConnected || this.initialized) return;
        this.initialized = true;
        this.productMeta=JSON.parse(this.querySelector('[data-sizing-product]').textContent);this.fitLabels=JSON.parse(this.querySelector('[data-fit-labels]').textContent);
        this.labels = JSON.parse(this.querySelector('[data-split-labels]').textContent);
        this.variants = JSON.parse(this.querySelector('[data-split-variants]').textContent);
        this.lengthIndex = Number(this.dataset.lengthIndex);
        this.units = 'cm';
        this.dialog = this.querySelector('[data-split-dialog]');
        this.input = this.querySelector('[data-split-wrist]');
        this.slider = this.querySelector('[data-split-slider]');
        this.error = this.querySelector('[data-split-error]');
        this.result = this.querySelector('[data-split-result]');
        this.querySelector('[data-split-open]').addEventListener('click', () => this.open());
        this.querySelector('[data-split-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('close', () => {
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.querySelector('[data-split-open]').focus({ preventScroll: true });
        });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        });
        this.querySelector('[data-split-measure-form]').addEventListener('submit', event => {
          event.preventDefault();
          this.calculate();
        });
        this.querySelectorAll('[data-split-unit]').forEach(button => button.addEventListener('click', () => this.setUnit(button.dataset.splitUnit)));
        this.input.addEventListener('input', () => {
          this.convertedValue = null;
          this.updateSlider(this.readWristCm());
          this.clearError();
          this.result.hidden = true;
        });
        this.slider.addEventListener('input', () => {
          const cm = Number(this.slider.value);
          this.input.value = String(this.units === 'in' ? Number((cm / 2.54).toFixed(2)) : cm);
          this.convertedValue = { cm, display: this.input.value };
          this.updateSlider(cm);
          this.clearError();
          this.result.hidden = true;
        });
        this.updateSlider(this.readWristCm());
      });
    }
    disconnectedCallback() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }
    text(key, values = {}) {
      let text = this.labels[key] || '';
      Object.entries(values).forEach(([name, value]) => { text = text.replaceAll('{' + name + '}', String(value)); });
      return text;
    }
    fmt(value) {
      return Number(value.toFixed(2)).toLocaleString(document.documentElement.lang || 'en', { maximumFractionDigits: 2 });
    }
    form() {
      return this.closest('.product-detail')?.querySelector('.js-qb-buy-buttons form');
    }
    picker() {
      return this.closest('.product-detail')?.querySelector('variant-picker');
    }
    selectedVariant() {
      const selectedId = this.form()?.querySelector('input[name="id"]')?.value || this.dataset.selectedId;
      return this.variants.find(variant => String(variant.id) === String(selectedId));
    }
    selectedPool() {
      const selected = this.selectedVariant();
      if (!selected) return [];
      return this.variants.filter(variant => variant.options.every((value, index) => index === this.lengthIndex || value === selected.options[index]));
    }
    open() {
      this.result.hidden = true;
      this.clearError();
      this.querySelector('[data-split-selected]').hidden = true;
      this.previousOverflow = document.documentElement.style.overflow;
      this.dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      this.input.focus();
    }
    clearError() {
      this.error.hidden = true;
      this.error.textContent = '';
      this.input.removeAttribute('aria-invalid');
    }
    showError(key) {
      this.error.textContent = this.text(key);
      this.error.hidden = false;
      this.input.setAttribute('aria-invalid', 'true');
    }
    readWristCm() {
      if (this.convertedValue && this.input.value === this.convertedValue.display) return this.convertedValue.cm;
      return this.units === 'in' ? Number(this.input.value) * 2.54 : Number(this.input.value);
    }
    updateSlider(cm) {
      const valid = this.input.value.trim() && Number.isFinite(cm) && cm > 0;
      if (valid) this.slider.value = String(Math.min(26, Math.max(13, cm)));
      this.slider.setAttribute('aria-valuetext', this.fmt(Number(this.slider.value)) + ' cm');
      this.querySelector('[data-split-slider-value]').textContent = valid ? this.fmt(cm) + ' cm (' + this.fmt(cm / 2.54) + ' in)' : '—';
      this.slider.style.setProperty('--split-progress', ((Number(this.slider.value) - 13) / 13 * 100) + '%');
    }
    setUnit(next) {
      if (next === this.units) return;
      const cm = this.readWristCm();
      if (this.input.value.trim() && Number.isFinite(cm)) {
        this.input.value = String(next === 'in' ? Number((cm / 2.54).toFixed(2)) : Number(cm.toFixed(6)));
        this.convertedValue = { cm, display: this.input.value };
      }
      this.units = next;
      this.querySelectorAll('[data-split-unit]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.splitUnit === next)));
      this.querySelector('[data-split-input-label]').textContent = this.text(next === 'in' ? 'measure_in' : 'measure_cm');
      this.querySelector('[data-split-unit-suffix]').textContent = this.text(next === 'in' ? 'input_suffix_in' : 'input_suffix_cm');
      this.querySelector('[data-split-unit-hint]').textContent = this.text(next === 'in' ? 'unit_hint_in' : 'unit_hint');
      this.updateSlider(cm);
      this.result.hidden = true;
      this.clearError();
    }
    calculate() {
      this.clearError();this.result.hidden=true;
      const value=Number(this.input.value),cm=this.readWristCm();
      if(!this.input.value.trim()||!Number.isFinite(value)||!Number.isFinite(cm)||cm<10||cm>35){this.showError('invalid');return;}
      this.wristCm=cm;
      const rec=window.CycoProductFit.recommend(this.productMeta,this.variants,this.selectedVariant()?.id,cm,'regular',null);
      const title=this.querySelector('[data-split-result-title]');
      title.textContent=rec.candidates.length?this.fitLabels.result_title:(rec.status==='unavailable'?this.fitLabels.result_unavailable:this.fitLabels.result_no_fit);
      this.querySelector('[data-split-result-note]').hidden=true;this.querySelector('[data-split-colour-note]').hidden=true;
      const note=this.querySelector('[data-split-fit-note]');note.hidden=false;note.textContent=this.fitLabels.split_chart_note;
      const choices=this.querySelector('[data-split-choices]');
      window.CycoProductFit.render(choices,rec,{labels:this.fitLabels,wrist:cm,format:n=>this.fmt(n)+' cm',contactUrl:((window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/')+'pages/contact-us',onChange:()=>{},onApply:(candidate,button)=>this.apply({length:candidate.cm},button)});
      this.querySelector('[data-split-alternative]').hidden=rec.candidates.length>0&&rec.candidates[0].fit==='chart';
      this.result.hidden=false;title.focus({preventScroll:true});
      this.result.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'nearest'});
    }
    async apply(band, button) {
      this.clearError();
      const variant = this.selectedPool().find(item => parseFloat(String(item.options[this.lengthIndex])) === band.length && item.available);
      if (!variant) { this.calculate(); this.showError('colour_changed'); return; }
      const picker = this.picker();
      const group = picker?.querySelector('.option-selector[data-index="' + (this.lengthIndex + 1) + '"]');
      if (!group) { this.showError('apply_error'); return; }
      const value = String(variant.options[this.lengthIndex]);
      const radio = [...group.querySelectorAll('.js-option')].find(element => String(element.value) === value);
      const select = group.querySelector('select');
      const customOption = [...group.querySelectorAll('.custom-select__option')].find(element => String(element.dataset.value || '').trim() === value);
      const colourBefore = this.selectedVariant()?.options.filter((_, index) => index !== this.lengthIndex).join(' / ');
      button.disabled = true;
      button.textContent = this.text('applying');
      if (radio && !radio.disabled) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (select) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (customOption) {
        customOption.click();
      } else {
        button.disabled = false;
        button.textContent = this.text('apply', { length: band.length });
        this.showError('apply_error');
        return;
      }
      let applied = false;
      for (let i = 0; i < 20; i++) {
        await new Promise(resolve => setTimeout(resolve, 100));
        const selectedId = this.form()?.querySelector('input[name="id"]')?.value;
        if (String(selectedId) === String(variant.id)) { applied = true; break; }
      }
      button.disabled = false;
      button.textContent = this.text('apply', { length: band.length });
      if (!applied) { this.showError('apply_error'); return; }
      this.dialog.close();
      const status = this.querySelector('[data-split-selected]');
      status.textContent = this.text('selected', { length: band.length, colour: colourBefore || '' });
      status.hidden = false;
      picker.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    }
  }
  customElements.define('cyco-split-size-finder', SplitFinder);
})();

